import mediaModel from 'models/media-model';
import PhotoViewer from 'views/photo-viewer';
import VideoViewer from 'views/video-viewer';
import AudioViewer from 'views/audio-viewer';
import FileViewer from 'views/file-viewer';
import mediaViewerModel from 'models/media-viewer-model';
import ThumbnailGallery from 'views/media-viewer/thumbnails/thumbnail-gallery';
import mediaListManager from 'managers/media-list-manager';

function getView(mediaId) {

    const media = mediaListManager.getMedia(mediaId);

    if (media) {

        if (!media.mimeType) {
            return FileViewer.notSupported(media);
        
        }  else if (media.isImage) {

            return <PhotoViewer media={media} key={media.mediaId} />;

        } else if (media.mimeType.startsWith('video')) {

            return <VideoViewer media={media} key={media.mediaId} />;

        } else if (media.mimeType.startsWith('audio')) {

            return <AudioViewer media={media} key={media.mediaId} />;

        } else if (mediaModel.isSupportedFileType(media)) {

            return <FileViewer media={media} key={media.mediaId} />;

        }

        return FileViewer.notSupported(media);
    }
}


const MediaViewer = {

    oninit: () => {
        window.addEventListener('keydown', mediaViewerModel.handleKeyDown);
    },

    onremove: () => {
        window.removeEventListener('keydown', mediaViewerModel.handleKeyDown);
    },

    view: () => {
        if (mediaViewerModel.isWaiting) {
            return <div className="media-viewer">
                <div className="media-viewer-stage">
                    <i className="icon-close" onclick={() => mediaViewerModel.close()}/>
                    <i className="spinner spinning"/>
                </div>
            </div>;
        }
        return <div class="media-viewer">
            <div class="media-viewer-stage">
                {!mediaViewerModel.inStandaloneMode && <i class="icon-close" onclick={() => mediaViewerModel.close()} />}
                {mediaViewerModel.hasPrev() && <i class="icon-left" onclick={() => mediaViewerModel.selectIndex(mediaViewerModel.state.index - 1)} />}
                {mediaViewerModel.hasNext() && <i class="icon-right" onclick={() => mediaViewerModel.selectIndex(mediaViewerModel.state.index + 1)} />}
                <div>{getView(mediaViewerModel.mediaIds[mediaViewerModel.state.index])}</div>
            </div>
            {!mediaViewerModel.inStandaloneMode && <ThumbnailGallery mediaIds={mediaViewerModel.mediaIds}
                activeIndex={mediaViewerModel.state.index}
                onClickFn={(index) => mediaViewerModel.selectIndex(index)}
            />}
        </div>;


    }
};

export default MediaViewer;

